import { render, staticRenderFns } from "./WatchMovieDia.vue?vue&type=template&id=70551be6&scoped=true"
import script from "./WatchMovieDia.vue?vue&type=script&lang=js"
export * from "./WatchMovieDia.vue?vue&type=script&lang=js"
import style0 from "./WatchMovieDia.vue?vue&type=style&index=0&id=70551be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70551be6",
  null
  
)

export default component.exports